import { type ReactNode, useCallback } from 'react'

import LoyaltySocietePointsFilterGroup from 'loyalty/components/LoyaltySocietePointsFilterGroup'
import useLoyaltyBurnExperiment from 'loyalty/hooks/useLoyaltyBurnExperiment'
import { deleteSearchParams, setSearchParamValue } from 'lib/url/searchUrlUtils'
import type { FilterControlChangeHandler } from './HotelSearchPageFilterPane.types'

interface Props {
  filters: App.OfferListFilters
  searchParams: string
  currentHash: string
  onFilterChange: FilterControlChangeHandler
  loading?: boolean
  children?: ReactNode
}

function HotelSearchSocieteFilters({ filters, searchParams, currentHash, onFilterChange, loading, children }: Props) {
  const { isAnyVariant: isBurnEnabled } = useLoyaltyBurnExperiment()
  const viewPriceInPoints = !!filters.viewPriceInPoints

  const handleViewPriceInPointsChange = useCallback((nextViewPriceInPoints: boolean) => {
    const newSearchParams = nextViewPriceInPoints
      ? setSearchParamValue(searchParams, 'viewPriceInPoints', 'true')
      : deleteSearchParams(searchParams, 'viewPriceInPoints')
    onFilterChange({ search: newSearchParams, hash: currentHash })
  }, [searchParams, currentHash, onFilterChange])

  if (!isBurnEnabled && !children) {
    return null
  }

  return (
    <LoyaltySocietePointsFilterGroup
      skipBurnExperiment
      loading={loading}
      viewPriceInPoints={viewPriceInPoints}
      onViewPriceInPointsChange={handleViewPriceInPointsChange}
      enableBurnControls={isBurnEnabled}
    >
      {children}
    </LoyaltySocietePointsFilterGroup>
  )
}

export default HotelSearchSocieteFilters
